module.exports = __webpack_public_path__ + "img/mod-2.58e94e0f.svg";